import { render } from "./Text3.vue?vue&type=template&id=0efc2d0c&scoped=true"
import script from "./Text3.vue?vue&type=script&lang=js"
export * from "./Text3.vue?vue&type=script&lang=js"
script.render = render
script.__scopeId = "data-v-0efc2d0c"

export default script